<div class="bg-brand-purple-50 rounded-lg p-3 space-y-1 mt-6" *ngIf="itens.length > 0">
    <div class="flex items-center justify-between">
        <p class="text-sm uppercase text-brand-purple-300">{{ titulo }}</p>
        <button class="btn-edit text-brand-purple-300" (click)="editarFiltro()">
            <span class="material-symbols-outlined">edit</span>
        </button>
    </div>
    <div>
        <p class="text-base text-brand-gray-400 font-medium"
            *ngFor="let item of (mostrarTodos ? itens : itens.slice(0, 5))">
            {{ item }}
        </p>
    </div>
    <p *ngIf="itens.length > 5">
        <a href="#" class="font-medium text-brand-purple-300" (click)="toggleMostrarTodos($event)">
            {{ mostrarTodos ? 'Ocultar' : 'Ver todos (' + itens.length + ')' }}
        </a>
    </p>
</div>
